import { sceneGraph } from './sceneGraph/index.js';
import { SceneObjectBase } from './SceneObjectBase.js';
import { evaluateTimeRange } from './SceneTimeRange.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class SceneTimeZoneOverride extends SceneObjectBase {
  constructor(state) {
    super(__spreadProps(__spreadValues({}, state), {
      timeZone: state.timeZone,
      from: "now-6h",
      to: "now",
      value: evaluateTimeRange("now-6h", "now", state.timeZone)
    }));
    this._activationHandler = () => {
      const timeRangeObject = this.getTimeRangeObject();
      const { from, to } = timeRangeObject.state;
      this.setState({
        from,
        to,
        value: evaluateTimeRange(from, to, this.state.timeZone)
      });
      this._subs.add(
        timeRangeObject.subscribeToState((n) => {
          this.setState({
            from: n.from,
            to: n.to,
            value: evaluateTimeRange(n.from, n.to, this.state.timeZone)
          });
        })
      );
    };
    this.addActivationHandler(this._activationHandler);
  }
  getTimeRangeObject() {
    if (!this.parent || !this.parent.parent) {
      throw new Error("SceneTimeZoneOverride must be used within $timeRange scope");
    }
    return sceneGraph.getTimeRange(this.parent.parent);
  }
  getTimeZone() {
    return this.state.timeZone;
  }
  onTimeRangeChange(timeRange) {
    const timeRangeObject = this.getTimeRangeObject();
    timeRangeObject.onTimeRangeChange(timeRange);
  }
  onTimeZoneChange(timeZone) {
    this.setState({ timeZone, value: evaluateTimeRange(this.state.from, this.state.to, timeZone) });
  }
  onRefresh() {
    const timeRangeObject = this.getTimeRangeObject();
    timeRangeObject.onRefresh();
  }
}

export { SceneTimeZoneOverride };
//# sourceMappingURL=SceneTimeZoneOverride.js.map
